module.exports = require("live/components/lists/ui/search");